const baseURL = 'https://regalosferxchu.negocioscuajimalpa.com/';

export default baseURL;
